import { render, staticRenderFns } from "./ViberMetrics.vue?vue&type=template&id=17d046f6"
import script from "./ViberMetrics.vue?vue&type=script&lang=js"
export * from "./ViberMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports